/** @jsx jsx */

import { jsx } from '@emotion/core';
import { IconButton, IconName } from '@zapier/design-system';

type Props = {
  label: string;
  name: IconName;
  isDisabled?: boolean;
  onClick?: () => void;
};

const SidebarButton = (props: Props) => {
  const { isDisabled, label, name, onClick } = props;
  return (
    <IconButton
      aria-label={label}
      disabled={isDisabled || onClick === undefined || onClick === null}
      icon={name}
      onClick={onClick}
    />
  );
};

export default SidebarButton;
